export const links = [
    {
        "nombre" : "Transparencia",
        "link" : "/Transparencia/Rubros",
        "submenu" : [
            {
                "subMenuNombre" : "48 Rubros",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
            {
                "subMenuNombre" : "Rubros Anteriores",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            }

            
        ]
    },

    {
        "nombre" : "Programas Alternativos",
        "link" : "/Protocolo",
        
    }

]
